<app-spinner [isEnable]="isSpinnerEnable" loaderClass="create-process-spinner"></app-spinner>
<div class="row detailed-process" *ngIf="processDetail">
    <ng-template #approveReportUpdateModal>
                <div>
                    <div class="modal-body">
                        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                            <div>
                                The action will clean existing report and generate new one in a while.                              
                                Do you want to continue?
                            </div>
                        </div>
                        <div class="btn-modal">
                            <span (click)="updateReportForSelected(processDetail.appraiseeProcessDetails, processDetail.processName)">Yes</span>
                            <span (click)="modalRef.hide()">No</span>
                        </div>
                    </div>
                </div>
    </ng-template>
    <ng-template #approveModal>
        <div>
            <div class="modal-body">
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                    <div>
                        Do you really want to send notifications?
                    </div>
                </div>
                <div class="btn-modal">
                    <span (click)="sendToAll()">Send to all</span>
                    <span (click)="sendToSelected(getSelected(processDetail.appraiseeProcessDetails))">Send to selected</span>
                </div>
            </div>
        </div>
    </ng-template>
    <div class="head-component m-b-25">
        <div class="row col-10 p-l-5 m-0 br-0 head-component for-fixed-component card">
            <div class="col-9 pt-4 pb-4 p-r-25 p-l-15 card-body d-flex align-items-center justify-content-between">
                <h5 class="m-0">
                    <span [routerLink]="['/admin/processes-list']" class="cursor-pointer head-main-component">Processes
                        <i class="mdi mdi-chevron-right"></i></span>
                    <span class="name-questionnaire">{{ processDetail.processName }}</span>
                </h5>
                <div class="btn-group" dropdown>
                    <button class="btn btn-outline download-pdf m-r-15" (click)="hideCombinedReport()"
                        *ngIf="isCombinedReportClicked">
                        Hide report
                    </button>
                    <button class="btn btn-outline download-pdf m-r-15" (click)="downloadPdf()"
                        *ngIf="isCombinedReportClicked">
                        Download Report
                    </button>
                    <div id="button-action" (click)="validateMenu()" class="action  m-t-10" dropdownToggle aria-controls="dropdown-action">
                        <span></span>
                    </div>
                    <div (click)="$event.stopPropagation()" id="dropdown-action" *dropdownMenu class="dropdown-menu"
                        aria-labelledby="button-action">
                        <div slimScroll alwaysVisible="true" width="auto" height="440px" size="3px">
                            <div class="d-flex m-b-15" (click)="appraiseeBlockVisible = !appraiseeBlockVisible"><span class="btn-expand" [class.btn-expand-down]="appraiseeBlockVisible"></span>Notify appraisee</div>
                            <div *ngIf="appraiseeBlockVisible" class="pl-4">
                                <div (click)="openModal(approveModal, notificationType.ActionAppraiseeNotification)"class="m-b-10"> Notify appraisee on the need for action on the process</div>
                                <div (click)="openModal(approveModal, notificationType.ActionAppraiseeReminder)"class="m-b-10"> Remind appraisee on the need for action on the process</div>
                                <div (click)="openModal(approveModal, notificationType.RespondentsConfirmedByHrAppraiseeNotification)" class="m-b-10"> Notify appraisee that HR confirmed respondents</div>
                                <div (click)="openModal(approveModal, notificationType.EndProcessAppraiseeNotification)" class="m-b-10"> Notify appraisee about end of the process</div>
                            </div>
                            <div class="d-flex m-b-15" (click)="respondentBlockVisible = !respondentBlockVisible"><span class="btn-expand" [class.btn-expand-down]="respondentBlockVisible"></span>Notify respondent</div>
                            <div *ngIf="respondentBlockVisible" class="pl-4">
                                <div (click)="openModal(approveModal, notificationType.NewSurveyRespondentNotification)" class="m-b-10">Notify respondent about new survey</div>
                                <div (click)="openModal(approveModal, notificationType.NewSurveyRespondentReminder)" class="m-b-10">Remind respondent about new survey</div>
                            </div>
                            <div class="d-flex m-b-15" (click)="pmBlockVisible = !pmBlockVisible"><span class="btn-expand" [class.btn-expand-down]="pmBlockVisible"></span>Notify PM</div>
                            <div *ngIf="pmBlockVisible" class="pl-4">
                                <div (click)="openModal(approveModal, notificationType.ProcessStartPmNotification)" class="m-b-10">Notify PM about start of the process</div>
                                <div (click)="openModal(approveModal, notificationType.EndProcessPmNotification)" class="m-b-10">Notify PM about end of the process</div>
                                <div (click)="openModal(approveModal, notificationType.RespondentConfirmPmReminder)" class="m-b-10">Remind PM to confirm respondents</div>
                                <div (click)="openModal(approveModal, notificationType.RespondentsConfirmedByHrPmNotification)" class="m-b-10">Notify PM that HR confirmed respondents</div>
                            </div>
                            <div (click)="sendHrSummary()" class="m-b-15">Send notification on process changes</div>
                            <!-- <div class="d-flex m-b-15" (click)="hrBlockVisible = !hrBlockVisible"><span class="btn-expand" [class.btn-expand-down]="hrBlockVisible"></span>Notify HR</div>
                            <div *ngIf="hrBlockVisible" class="pl-4">
                                <div (click)="openModal(approveModal, notificationType.RespondentConfirmHrNotification)" class="m-b-10">Notify HR to confirm respondents</div>
                                <div (click)="openModal(approveModal, notificationType.RespondentConfirmHrReminder)" class="m-b-10">Remind HR to confirm respondents</div>
                                <div (click)="openModal(approveModal, notificationType.EndProcessHrNotification)" class="m-b-10">Notify HR about end of the process</div>
                            </div> -->
                            <hr />
                            <div *ngIf="isDeadlineChangingAvailable()" (click)="onChangeDeadlineClicked()">Change deadline for selected
                            <hr />
                            </div>
                            <div (click)="cancelSelectedParticipations(getSelected())" class="m-b-15">Cancel the process for selected</div>
                            <div (click)="cancelProcess()" class="m-b-15">Cancel the whole process</div>
                            <div *ngIf="canRespondentsBeDeleted()" (click)="deleteSelectedRespondents(getSelectedRespondents())" class="m-b-15">Delete selected</div>
                            <div *ngIf="addRespondentsVisible" (click)="openAddRespondentModal()" class="m-b-15">Add respondents</div>
                            <hr />
                            <div class="m-b-5" *ngIf="isCombinedProcesses(processDetail.appraiseeProcessDetails)">
                                <span (click)="showCombinedReport(processDetail)" *ngIf="!isCombinedReportClicked">Show
                                    combined process report</span>
                                <span (click)="hideCombinedReport()" *ngIf="isCombinedReportClicked">Hide combined
                                    process report</span>
                            </div>
                            <div class="m-b-5" (click)="downloadExcelReport(processDetail.processName, getSelected(processDetail.appraiseeProcessDetails))"> Download process report</div>
                            <div (click)="downloadIndividualReport(processDetail.appraiseeProcessDetails, processDetail.processName)" class="m-b-15">Download individual appraisee report</div>
                            <div (click)="openModalByTemplate(approveReportUpdateModal)" class="m-b-15"> Update report for an selected appraisee</div>
                            <hr />
                            <div (click)="generateLink(processDetail.processId)" class="m-b-15"> Generate Link</div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showProcessReopenButton" class="col-3 pr-4 d-flex justify-content-end">
                <button class="reopen-process-btn mr-4" (click)="openReopenProcessModal()"> Reopen process </button>
            </div>
        </div>
    </div>
    <div class="col-9 p-r-0 p-l-25">
            <div *ngIf="!detailedCombinedReport && appraiseeProcessDetails.length" [class.process-header]="!detailedCombinedReport" class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="checked-pocesses d-flex">
                        <button class="select-all" (click)="selectAll()"> Select All </button>
                        <button *ngIf="isSelectActiveAvailable" (click)="selectAllActive()" class="select-all pl-2"> Select all active </button>
                    </div>
                    <div *ngIf="getSelectedProcesses().length" class="checked-pocesses d-flex">
                        <div><span>{{ getSelectedProcesses().length }}</span> {{ getSelectedProcesses().length > 1 ? 'items selected' : 'item selected' }}</div>
                        <button (click)="clearSelection()"><i class="ti-close"></i></button>
                    </div>
                </div>   
                <div>
                    <label *ngIf="getIsImportBtnEnabled()" for="file" class="btn-import-file">Import</label>
                    <input type="file" id="file" (change)="getFile($event)" #fileInput required />
                    <button (click)="exportSelectedParticipations(getSelected(processDetail.appraiseeProcessDetails))" class="btn-import-file">Export</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="width m-t-30" *ngIf="!detailedCombinedReport">
                    <div class="d-flex align-items-center"
                        *ngFor="let appraiseeProcessDetail of appraiseeProcessDetails | paginate: { itemsPerPage: pageSize, currentPage: pageNumber }; let i = index;">
                        <input type="checkbox" [id]="i" [checked]="appraiseeProcessDetail.isAppraiseeSelected"
                            (click)="toggleSelectParent(appraiseeProcessDetail)">
                        <label [for]="i"> </label>
                        <app-detailed-process-appraisee class="width"
                            [knownProcessTypes]="processDetail.processKnownTypes"
                            [respondentSelectionValues]="processDetail.respondentSelectionValues"
                            [appraiseeProcessDetail]="appraiseeProcessDetail"
                            [stages]="processDetail.availableProcessParticipationStages"
                            [selectedProcessDurationId]="selectedProcessDurationId" (saveClicked)="loadProcessDetail()"
                            (respondentsAdded)="loadProcessDetail()">
                        </app-detailed-process-appraisee>
                    </div>

                    <div *ngIf="appraiseeProcessDetails.length" class="text-center">
                        <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
                    </div>
                </div>
                <div *ngIf="detailedCombinedReport">
                    <div class="card" #combinedReportContent>
                        <div class="card-body detailed-report">
                            <div class="row">
                                <app-report-description-module [isIndividualBriefReport]="false" class="col-4"
                                    [processInfoReport]="processInfo"></app-report-description-module>
                            </div>
                            <app-detailed-report-faq [isCombinedReport]="true"></app-detailed-report-faq>
                            <app-categories [detailReportCategories]="detailedCombinedReport.categories">
                            </app-categories>
                            <app-text-questions-module
                                [textQuestionCategories]="detailedCombinedReport.textQuestionCategories">
                            </app-text-questions-module>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="col-3 p-l-25 position-relative">
            <div class="fixed-right">
                <div class="mb-3 name-questionnaire">
                    {{ processDetail.processName }}
                </div>
                <div class="m-b-20">
                    <div class="caption">
                        Survey:
                    </div>
                    <div class="lh-1-1">
                        {{ processDetail.surveyName }}
                    </div>
                </div>
                <div class="m-b-20 process-dates">
                    <div class="caption">
                        Process Dates:
                    </div>
                    <div>
                        <div class="for-ngx-select">
                            <ngx-select (select)="selectProcessDuration($event)"
                                [items]="getDatesRange(processDetail.processDurations)"
                                [defaultValue]="selectedProcessDurationId">
                            </ngx-select>
                        </div>
                    </div>
                </div>
                <div class="m-b-20">
                    <div class="caption">
                        Business Unit appraisee:
                    </div>
                    <div class="w-100">
                        <ngx-select [items]="getBusinessUnits(processDetail.appraiseeProcessDetails)"
                            [formControl]="selectBusinessUnit" [allowClear]="true" (remove)="removeBusinessUnit()"
                            placeholder=""></ngx-select>
                    </div>
                </div>
                <div class="m-b-20">
                    <div class="caption">
                        Grade appraisee:
                    </div>
                    <div class="w-100">
                        <ngx-select [items]="getGrades(processDetail.appraiseeProcessDetails)"
                            [formControl]="selectGrade" [allowClear]="true" (remove)="removeGrade()" placeholder="">
                        </ngx-select>
                    </div>
                </div>
                <div class="m-b-20">
                    <div class="caption">
                        Appraisee:
                    </div>
                    <div>
                        <ngx-select [items]="getAppraisees(processDetail.appraiseeProcessDetails)"
                            [formControl]="selectAppraisee" [allowClear]="true" (remove)="removeAppraisee()">
                        </ngx-select>
                    </div>
                </div>
                <div class="m-b-20">
                    <div class="caption">
                        Respondent:
                    </div>
                    <div>
                        <ngx-select [items]="getRespondents(processDetail.appraiseeProcessDetails)"
                            [formControl]="selectRespondent" [allowClear]="true" (remove)="removeRespondent()">
                        </ngx-select>
                    </div>
                </div>
            </div>
    </div>
</div>
<ng-template #approveModal>
  <div class="modal-form modal-content sub-modal">
    <app-spinner
    [isEnable]="isSpinnerEnable"
    loaderClass="reopen-process-loader">
  </app-spinner>
    <div class="modal-body">
        <button class="close-modal-btn" (click)="subModalRef.hide()"></button>
        <div class="d-flex justify-content-center flex-column" style="min-height: 90px;">
            <div>
                Do you want to send notifications?
            </div>
        </div>
    </div>
    <div class="btn-modal">
        <span (click)="onNotificationSelect(true)">Yes</span>
        <span (click)="onNotificationSelect(false)">No</span>
    </div>
  </div>
</ng-template>